import actions from './actions';
import reducer from './reducer';

const oneClickPrescribeQueue = {
    actions,
    reducer,
    name: 'oneClickPrescribeQueue',
};

export default oneClickPrescribeQueue;

